<template>
  <div class="card-resumen">
    <div class="card-body">
      <div class="title text-landing semibold pb-3">
        {{ isPagoUnicoForced || hitosPagoNext.length <= 1 ? $t('reserva.uniquePayment') : $t('reserva.howPay') }}
      </div>
      <div>
        <div
          class="d-flex align-items-center justify-content-between"
          :class="{ 'mb-2': hitosPagoNext.length > 1 && !isPagoUnicoForced }">
          <input
            id="precioTotal"
            type="radio"
            name="modoPago"
            class="d-none"
            :checked="modoPago === TIPOS_PAGO.ALL"
            @change="optionsChange(TIPOS_PAGO.ALL)" />

          <label
            for="precioTotal"
            class="w-100 d-flex align-items-center pointer"
            :class="{ bold: modoPago === TIPOS_PAGO.ALL }">
            <span class="d-flex justify-content-center align-items-center">
              <RadioButtonIcon :is-selected="modoPago === TIPOS_PAGO.ALL" />
            </span>
            <span v-if="!isPagosSucesivos" class="ml-10 text-landing">
              {{ $t('reserva.pagarTotalReserva') }} ({{ formatPrice(precioTotal) }} {{ agenciaStore.getCurrency }})
            </span>
            <span v-else class="ml-10 text-landing">
              {{ $t('reserva.pagarTotalRestante') }} ({{ formatPrice(totalPagarRestante) }}
              {{ agenciaStore.getCurrency }})
            </span>
          </label>
        </div>
        <template v-if="hitosPagoNext.length > 1 && !isPagoUnicoForced">
          <div :class="{ 'mb-2': showPastOption }">
            <input
              id="precioInicial"
              type="radio"
              name="modoPago"
              class="d-none"
              :disabled="isPlazosDisabled"
              :checked="modoPago === TIPOS_PAGO.NEXT"
              :class="{ 'opacity-50': isPlazosDisabled }"
              @change="optionsChange(TIPOS_PAGO.NEXT)" />
            <label
              for="precioInicial"
              class="w-100 d-flex align-items-center justify-content-start"
              :class="{
                bold: modoPago === TIPOS_PAGO.NEXT,
                'opacity-50': isPlazosDisabled,
                pointer: !isPlazosDisabled,
              }">
              <span class="d-flex justify-content-center align-items-center">
                <RadioButtonIcon :is-selected="modoPago === TIPOS_PAGO.NEXT" />
              </span>
              <span class="ml-10 text-landing">
                {{ $t('reserva.pagarEnPlazos', { count: hitosPagoNext.length }) }}
              </span>
            </label>
          </div>
          <div
            v-if="modoPago === TIPOS_PAGO.NEXT && hitosPagoNext.length > 1"
            class="ml-10 mt-10 text-landing"
            :class="{ 'mb-2': showPastOption }">
            <div
              v-for="(hito, index) in hitosPagoNext"
              :key="index"
              class="pago"
              :class="{ 'opacity-50': isPlazosDisabled }">
              <div v-if="index !== hitosPagoNext.length - 1">
                <span class="pagos me-2"> {{ index + 1 }}º {{ $t('reserva.pago.label') }}</span>
                <span v-if="index === 0 && !isPagosSucesivos">
                  {{
                    $t('reserva.pagos.pagaAhora', {
                      cantidad: formatPrice(hito.cantidadPendiente),
                      currency: agenciaStore.getCurrency,
                    })
                  }}
                </span>
                <span v-else>
                  {{
                    $t('reserva.pagos.pagaAntesDel', {
                      cantidad: formatPrice(hito.cantidadPendiente),
                      currency: agenciaStore.getCurrency,
                      fecha: moment.tz(hito.fecha, viaje.timezone).local().format('DD/MM/YYYY'),
                      hora: moment.tz(hito.fecha, viaje.timezone).local().format('HH:mm'),
                    })
                  }}
                </span>
              </div>
              <div v-else>
                <span class="pagos me-2">{{ index + 1 }}º {{ $t('reserva.pago.label') }}</span>
                <span>
                  {{
                    $t('reserva.pagos.pagaAntesDel', {
                      cantidad: formatPrice(hito.cantidadPendiente),
                      currency: agenciaStore.getCurrency,
                      fecha: moment.tz(hito.fecha, viaje.timezone).local().format('DD/MM/YYYY'),
                      hora: moment.tz(hito.fecha, viaje.timezone).local().format('HH:mm'),
                    })
                  }}
                </span>
              </div>
            </div>
          </div>

          <div v-if="showPastOption">
            <input
              id="precioPast"
              type="radio"
              name="modoPago"
              class="d-none"
              :disabled="isPlazosDisabled"
              :checked="modoPago === TIPOS_PAGO.PAST"
              :class="{ 'opacity-50': isPlazosDisabled }"
              @change="optionsChange(TIPOS_PAGO.PAST)" />
            <label
              for="precioPast"
              class="w-100 d-flex align-items-center justify-content-start"
              :class="{
                bold: modoPago === TIPOS_PAGO.PAST,
                'opacity-50': isPlazosDisabled,
                pointer: !isPlazosDisabled,
              }">
              <span class="d-flex justify-content-center align-items-center">
                <RadioButtonIcon :is-selected="modoPago === TIPOS_PAGO.PAST" />
              </span>
              <span class="ml-10 text-landing">
                {{ $t('reserva.pagarEnPlazos', { count: hitosPagoPast.length }) }}
              </span>
            </label>
          </div>
          <div v-if="modoPago === TIPOS_PAGO.PAST && hitosPagoPast.length > 1" class="ml-10 mt-10 text-landing">
            <div
              v-for="(hito, index) in hitosPagoPast"
              :key="'past-' + index"
              class="pago"
              :class="{ 'opacity-50': isPlazosDisabled }">
              <div v-if="index !== hitosPagoPast.length - 1">
                <span class="pagos me-2"> {{ index + 1 }}º {{ $t('reserva.pago.label') }}</span>
                <span v-if="index === 0 && !isPagosSucesivos">
                  {{
                    $t('reserva.pagos.pagaAhora', {
                      cantidad: formatPrice(hito.cantidadPendiente),
                      currency: agenciaStore.getCurrency,
                    })
                  }}
                </span>
                <span v-else>
                  {{
                    $t('reserva.pagos.pagaAntesDel', {
                      cantidad: formatPrice(hito.cantidadPendiente),
                      currency: agenciaStore.getCurrency,
                      fecha: moment.tz(hito.fecha, viaje.timezone).local().format('DD/MM/YYYY'),
                      hora: moment.tz(hito.fecha, viaje.timezone).local().format('HH:mm'),
                    })
                  }}
                </span>
              </div>
              <div v-else>
                <span class="pagos me-2">{{ index + 1 }}º {{ $t('reserva.pago.label') }}</span>
                <span>
                  {{
                    $t('reserva.pagos.pagaAntesDel', {
                      cantidad: formatPrice(hito.cantidadPendiente),
                      currency: agenciaStore.getCurrency,
                      fecha: moment.tz(hito.fecha, viaje.timezone).local().format('DD/MM/YYYY'),
                      hora: moment.tz(hito.fecha, viaje.timezone).local().format('HH:mm'),
                    })
                  }}
                </span>
              </div>
            </div>
          </div>
          <span v-if="isPlazosDisabled" class="fechavenc-span">
            {{
              $t('reserva.pagoPlazosDeshabilitado', {
                fecha: moment.tz(fechaVencimientoHitoActualAlreadyPayed, viaje.timezone).local().format('DD/MM/YYYY'),
                hora: moment.tz(fechaVencimientoHitoActualAlreadyPayed, viaje.timezone).local().format('HH:mm'),
              })
            }}
          </span>
        </template>
      </div>
    </div>
  </div>
</template>

<script setup>
  import RadioButtonIcon from '@/components/Icons/RadioButtonIcon.vue';
  import { calcularPagoRestante } from '@/helpers/hitosPagoUtils';
  import { TIPOS_PAGO } from '@/constants/viajeConstants';
  import { computed, nextTick, onMounted, ref, watch } from 'vue';
  import { agenciaStoreModule } from '@/store_pinia/agencia';
  import { formatPrice } from '@/helpers/numberUtils';
  import moment from 'moment-timezone';

  const props = defineProps({
    viaje: {
      type: Object,
      required: true,
    },
    hitosPagoNext: {
      type: Array,
      required: true,
    },
    hitosPagoPast: {
      type: Array,
      default: () => [],
    },
    isPagoUnicoForced: {
      type: Boolean,
      default: false,
    },
    isPagosSucesivos: {
      type: Boolean,
      default: false,
    },
    precioTotal: {
      type: Number,
      required: true,
    },
    totalPagado: {
      type: Number,
      default: 0,
    },
    fechaVencimientoHitoActualAlreadyPayed: {
      type: String,
      default: null,
    },
    selectedPasarelaPago: {
      type: Object,
      required: true,
    },
  });

  const emits = defineEmits(['modo-pago', 'total-pendiente']);

  const agenciaStore = agenciaStoreModule();
  const modoPago = ref(TIPOS_PAGO.ALL);

  const totalPagarRestante = computed(() => calcularPagoRestante(props.precioTotal, props.totalPagado));
  const isPlazosDisabled = computed(
    () => props.isPagosSucesivos && props.fechaVencimientoHitoActualAlreadyPayed !== null
  );
  const showPastOption = computed(() => props.hitosPagoPast.length > props.hitosPagoNext.length);

  function optionsChange(selectedValue) {
    modoPago.value = selectedValue;
    emits('modo-pago', selectedValue);
  }

  watch(
    () => props.isPagoUnicoForced,
    forced => {
      if (forced && modoPago.value !== TIPOS_PAGO.ALL) {
        optionsChange(TIPOS_PAGO.ALL);
      }
    }
  );

  onMounted(async () => {
    await nextTick();
    emits('modo-pago', modoPago.value);
  });

  watch(
    totalPagarRestante,
    newValue => {
      emits('total-pendiente', newValue.value);
    },
    { immediate: true }
  );
</script>

<style scoped lang="scss">
  .card-resumen {
    border-radius: var(--bs-border-radius-xl);
    border: 1px solid rgba(var(--landing-text-color-rgb, var(--bs-primary-rgb)), 0.25);
  }

  .card-body {
    padding: 20px;
  }

  .title {
    font-size: 16px;
    font-weight: 600;
  }

  .pago {
    border-left: 2px solid var(--landing-detail-color, var(--bs-secondary));
    padding-left: 8px;
    padding-bottom: 10px;
    &:last-child {
      padding-bottom: 0;
    }
  }

  .pagos {
    font-size: 12px;
    font-weight: 700;
    color: var(--landing-detail-color, var(--bs-secondary));
  }

  .fechavenc-span {
    font-size: 13px;
    color: var(--landing-text-color, var(--bs-primary));
  }
</style>
